export default __webpack_public_path__ + "static/media/profile.41ec7b2b.svg";